<div [class.error]="toast.style === notificationStyle.Error" [class.warning]="toast.style === notificationStyle.Warning" class="toast">
  <h1 *ngIf="toast?.title" class="title">{{ toast.title }}</h1>
  <p *ngIf="toast?.text" class="text">{{ toast.text }}</p>

  <div
    (click)="toggleDontShowMeAgain()"
    *ngIf="toast.recurrence === notificationRecurrence.AlwaysWithDismissOption"
    class="dont-show-me-again"
  >
    <div [class.selected]="dontShowMeAgain" class="checkbox">
      <i *ngIf="dontShowMeAgain" class="fa fa-check"></i>
    </div>
    <span transloco="Don't show again"></span>
  </div>

  <!--
    ***
    ***   Buttons
    ***
  -->
  <div
    *ngIf="toast?.buttons?.length"
    [class.many-buttons]="toast?.buttons?.length > 2"
    [class.two-buttons]="toast?.buttons?.length === 2"
    class="buttons"
  >
    <div
      (click)="handleButtonClick(button)"
      *ngFor="let button of toast.buttons"
      [class.flat-button]="button.style === 'flat'"
      [class.primary-button]="button.style === 'primary'"
      [class.secondary-button]="button.style === 'secondary'"
      [class.tertiary-button]="button.style === 'tertiary'"
      class="button small wider"
    >
      {{ button.label }}
    </div>
  </div>

  <!--
    ***
    ***   Default button if buttons aren't set
    ***
  -->
  <div *ngIf="!toast?.buttons?.length" class="buttons default">
    <svg (click)="close()" class="close-icon" fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.7338 10.2753C21.3788 9.92036 20.8055 9.92036 20.4505 10.2753L16 14.7167L11.5495 10.2662C11.1945 9.91126 10.6212 9.91126 10.2662 10.2662C9.91126 10.6212 9.91126 11.1945 10.2662 11.5495L14.7167 16L10.2662 20.4505C9.91126 20.8055 9.91126 21.3788 10.2662 21.7338C10.6212 22.0887 11.1945 22.0887 11.5495 21.7338L16 17.2833L20.4505 21.7338C20.8055 22.0887 21.3788 22.0887 21.7338 21.7338C22.0887 21.3788 22.0887 20.8055 21.7338 20.4505L17.2833 16L21.7338 11.5495C22.0796 11.2036 22.0796 10.6212 21.7338 10.2753V10.2753Z"
        fill="#6C7578"
      />
    </svg>
  </div>
</div>
